export default __webpack_public_path__ + "static/media/xlsIcon.3c3d825a.png";